export interface LeadProps {
  id: number;
  chatId: number;
  messageId: number;
  senderUsername?: string | null;
  messageText: string;
  messageLink: string;
  topic?: string | null;
  createdAt: Date;
  isConfirmed?: boolean;
  isTarget?: boolean;
  processedAt?: Date;
  senderId?: number;
}

export class LeadEntity {
  private readonly props: LeadProps;
  
  private constructor(props: LeadProps) {
    this.props = { ...props };
  }

  static create(props: LeadProps): LeadEntity {
    return new LeadEntity(props);
  }

  get id(): number { return this.props.id; }
  get chatId(): number { return this.props.chatId; }
  get messageId(): number { return this.props.messageId; }
  get senderUsername(): string | null | undefined { return this.props.senderUsername; }
  get messageText(): string { return this.props.messageText; }
  get messageLink(): string { return this.props.messageLink; }
  get topic(): string | null | undefined { return this.props.topic; }
  get createdAt(): Date { return this.props.createdAt; }
  get isConfirmed(): boolean | undefined { return this.props.isConfirmed; }
  get isTarget(): boolean | undefined { return this.props.isTarget; }
  get processedAt(): Date | undefined { return this.props.processedAt; }
  get senderId(): number | undefined { return this.props.senderId; }

  toJSON() { return { ...this.props }; }
}